import { ROI_SUMMARY, CLIENTS } from "@/data/mock";

export default function AdminROI() {
  const r = ROI_SUMMARY;
  return (
    <div className="space-y-10">
      <div>
        <div className="eyebrow">// ROI Intelligence</div>
        <h1 className="display-lg text-silver-50 mt-2">Every dollar. Every client.</h1>
      </div>
      <div className="grid gap-6 md:grid-cols-4">
        <Card label="Revenue" value={`$${(r.totalRevenue / 1000).toFixed(0)}k`} color="text-brand-blue" />
        <Card label="Spend" value={`$${(r.totalSpend / 1000).toFixed(0)}k`} color="text-silver-100" />
        <Card label="ROAS" value={`${r.roas.toFixed(2)}x`} color="text-brand-red" />
        <Card label="Leads" value={r.leads.toLocaleString()} color="text-silver-100" />
      </div>

      <div className="panel p-6">
        <div className="eyebrow">// Per-client performance</div>
        <div className="mt-5 overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left font-mono text-[10px] uppercase tracking-widest text-silver-300">
                <th className="py-3 pr-4">Client</th>
                <th className="py-3 pr-4">BSS</th>
                <th className="py-3 pr-4">CPL</th>
                <th className="py-3 pr-4">Trend</th>
                <th className="py-3 pr-4">Status</th>
              </tr>
            </thead>
            <tbody className="text-silver-100">
              {CLIENTS.map((c) => (
                <tr key={c.id} className="border-t border-ink-700/60">
                  <td className="py-3 pr-4 font-display font-semibold">{c.name}</td>
                  <td className="py-3 pr-4 font-mono">{c.bss}</td>
                  <td className="py-3 pr-4 font-mono">{c.cpl ? `$${c.cpl}` : "—"}</td>
                  <td className="py-3 pr-4 font-mono text-brand-blue">{c.trend}</td>
                  <td className="py-3 pr-4 text-silver-300">{c.status}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

function Card({ label, value, color }: { label: string; value: string; color: string }) {
  return (
    <div className="panel-hi p-6">
      <div className="eyebrow">// {label}</div>
      <div className={`mt-2 font-display font-extrabold text-4xl ${color}`}>{value}</div>
    </div>
  );
}
